import { Routes, Route } from 'react-router-dom';

import { setLocale } from 'yup';
import { useIntl } from 'react-intl';

import moment from 'moment';
import timezone from 'moment-timezone';
import 'moment/locale/de';

import messages from 'src/messages';
import { ProtectedRoute } from 'src/utils/authentication';

// Pages
import HomePage from 'src/pages/HomePage';
import FinesPage from 'src/pages/FinesPage';
import SetupPage from 'src/pages/SetupPage';
import LoginPage from 'src/pages/Auth/LoginPage';
import ProjectsPage from 'src/pages/ProjectsPage';
import ContractsPage from 'src/pages/ContractsPage';
import GatekeeperPage from 'src/pages/GatekeeperPage';
import DynamicFieldsPage from 'src/pages/DynamicFieldsPage';
import CancellationsPage from 'src/pages/CancellationsPage';
import CandidatesPage from 'src/pages/CandidatesPage';
import CandidatesDetailsPage from 'src/pages/CandidatesDetailsPage';
import VerificationsPage from 'src/pages/VerificationsPage';
import ProjectDetailsPage from 'src/pages/ProjectDetailsPage';
import TutorialDetailsPage from 'src/pages/TutorialDetailsPage';
import TimeTrackingPage from 'src/pages/TimeTrackingPage';
import PayrollPage from 'src/pages/PayrollPage';
// import AutoAcceptancePage from 'src/pages/AutoAcceptance';

const Router = () => {
  const { formatMessage } = useIntl();

  timezone.tz.setDefault('Europe/Berlin');
  moment.locale('de');

  /* eslint-disable */
  setLocale({
    mixed: {
      required: formatMessage(messages.requiredField),
      notType: (params: any) => {
        const args = { type: params.type };
        if (params.path.toLowerCase().includes('time')) args.type = 'time';
        return formatMessage(messages.notTypeField, args);
      },
    },
    number: {
      integer: formatMessage(messages.integerField),
      positive: formatMessage(messages.positiveField),
      min: (params: any) => formatMessage(messages.minValueField, params),
      max: (params: any) => formatMessage(messages.maxValueField, params),
    },
    date: {
      min: ({ min }: any) =>
        formatMessage(messages.minDateField, { min: min.format('L') }),
      max: ({ max }: any) =>
        formatMessage(messages.maxDateField, { max: max.format('L') }),
    },
  });

  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/gatekeeper" element={<GatekeeperPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/project_details/:uuid" element={<ProjectDetailsPage />} />
        <Route path="/contracts" element={<ContractsPage />} />
        <Route path="/cancellations" element={<CancellationsPage />} />
        <Route path="/fines" element={<FinesPage />} />
        <Route path="/students" element={<CandidatesPage />} />
        <Route path="/students/:uuid" element={<CandidatesDetailsPage />} />
        <Route path="/setup" element={<SetupPage />} />
        <Route
          path="/tutorial_details/:uuid"
          element={<TutorialDetailsPage />}
        />
        <Route
          path="/categories/:uuid/dynamic_fields"
          element={<DynamicFieldsPage />}
        />
        <Route path="/verifications" element={<VerificationsPage />} />
        <Route path="/payroll" element={<PayrollPage />} />
        <Route path="/time_tracking" element={<TimeTrackingPage />} />
        {/* <Route path="/auto_acceptance" element={<AutoAcceptancePage />} /> */}
      </Route>
    </Routes>
  );
};

export default Router;
